/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const UserEditIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'User Edit',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m18.57102,10.04276c-.9659-.79146-2.4532-.68844-3.379.2393l-4.1826,4.1826c-.248.2476-.4326.5557-.5332.8906l-.95408,3.1597c-.08008.2647-.00781.5518.1875.7471.14258.1426.33398.2197.53028.2197.0723,0,.1455-.0102.2168-.0322l3.1582-.9536c.3359-.1011.6445-.2852.8906-.5327,0,0,4.125-4.1246,4.2529-4.253.4932-.4927.7569-1.1753.7217-1.872-.0342-.6968-.3662-1.3511-.9091-1.7955Zm-7.209,7.5664l.5508-1.8212c.017-.0574.0578-.1019.0903-.1517l1.3323,1.3322c-.0501.0328-.0948.0737-.1531.0914l-1.8203.5493Zm6.3349-4.9585c-.0927.0933-2.2512,2.2515-3.4558,3.4559l-1.3764-1.376,3.3879-3.388c.2217-.2216.5127-.3369.793-.3369.2099,0,.4131.065.5761.1983.2188.1787.3467.4306.3604.7085.0137.2783-.0869.54-.2852.7382Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="m8.99983,11.24967c-2.61914,0-4.75-2.24316-4.75-5S6.38069,1.24967,8.99983,1.24967s4.75,2.24316,4.75,5-2.13086,5-4.75,5Zm0-8.5c-1.79199,0-3.25,1.57031-3.25,3.5s1.45801,3.5,3.25,3.5,3.25-1.57031,3.25-3.5-1.45801-3.5-3.25-3.5Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="m1.75081,18.74967c-.02393,0-.04834-.00098-.07275-.00391-.4126-.03906-.71436-.40527-.6748-.81836.30664-3.18359,3.81934-5.67773,7.99658-5.67773.24805,0,.49316.00879.73438.02539.41309.02832.72461.38672.6958.7998s-.38135.71094-.80029.69629c-.20703-.01465-.41699-.02148-.62988-.02148-3.41309,0-6.27002,1.89844-6.50342,4.32227-.0376.3877-.36377.67773-.74561.67773Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
